module.exports = __webpack_public_path__ + "img/categories.9dd0f2f7.svg";